import React, { isValidElement } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'styled-components';

import { useTheme } from '@webtrader/core/services/theme/v2';

export const uuid = () => {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return s4() + '-' + s4() + '-' + s4();
};

const portal = (
  renderer: (onClose: () => void) => JSX.Element,
  forOCT = false,
  rootNode = document.getElementById('overlay')
): void => {
  if (!renderer) {
    return;
  }

  /** If noRepeat, Check for existing component */
  const children = rootNode?.children;
  if (children) {
    for (let i = 0; i < children.length; i++) {
      const item = children[i];
      const className = item.className;
      if (className.split('-').includes('oct') && forOCT) {
        return;
      }
    }
  }

  /** RETRIEVE DOM FOR BODY COMPONENT */
  const rootContainer = rootNode ? rootNode : document.body;

  /** CREATE SEPARATE DIV FOR PORTAL COMPONENT WITHIN OVERLAY DIV */
  const portalNode = document.createElement('div');
  const portalRoot = createRoot(portalNode);
  portalNode.className = forOCT ? `react-portal-oct-confirmation` : `react-portal-${uuid()}`;

  /** CREATE COMPONENT WITH CLOSE FUNCTION */
  const element = renderer(() => {
    if (portalNode) {
      portalRoot.unmount();
      portalNode.remove();
    }
  });

  /** MOUNT COMPONENT TO ROOT NODE */
  if (rootContainer && isValidElement(element)) {
    portalRoot.render(<PortalProvider>{element}</PortalProvider>);
    rootContainer.appendChild(portalNode);
  }
};

export default portal;

export const PortalProvider: FCC = (props) => {
  const { children } = props;

  const { theme } = useTheme();

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
